<template>
    <div class="wrapper-confirm-redeem">
        <div class="confirm-redeem-headline" v-if="!isSurvey">{{lbl.confirm_redeem.headline}}</div>
        <div class="campaign-img">
            <img :src="campaign.fullImageUrl" class="img-fluid"/>
        </div>
        <div class="confirm-redeem-txt">
            <p>{{msg}} 
                <span class="text-pink">{{campaign.pointPerUnit > 0 ? campaign.pointPerUnit : lbl.campaign.free}}</span>
                <img src="../../../../../assets/icon/reward_icon_coin.png"><br>
                {{msg2}}
            </p>
            <p class="text-pink" 
                v-if="campaign.minutesValidAfterUsed && campaign.minutesValidAfterUsed > 0"
                v-html="minutesMsg">
            </p>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from '@/helper/Utility.js';
export default {
    name: 'DefaultConfirmRedeem',
    props: {
        lbl: Object,
        campaign: Object
    },
    data: function () {
        return {
            msg: '',
            minutesMsg: '',
            isHaveMinute: false,
            isSurvey: false,
        };
    },
    created: function () {
        var minutes = this.campaign.minutesValidAfterUsed;
        this.msg = this.lbl.confirm_redeem.default;
        this.msg2 = this.lbl.confirm_redeem.default_question;

        this.checkSurvey();

        if (minutes) {
            var days = '';
            var hours = '';
            var result = '';
            if (minutes >= 60) {
                hours = Math.floor(minutes / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lbl.date.days + ' ';
            if (hours) result += hours + ' ' + this.lbl.date.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lbl.date.minutes;

            this.isHaveMinute = true;
            this.minutesMsg = Util.stringFormat(this.lbl.confirm_redeem.default_have_time, result);
        } else {
            this.isHaveMinute = false;
            this.minutesMsg = this.lbl.confirm_redeem.default;
        }
    },
    methods: {
        checkSurvey : function(){
            if (this.campaign.type == Vue.CampaignType.Interface) {
                if(this.campaign.interfaceDisplay == 'surveyapprove' || this.campaign.interfaceDisplay == 'survey') {
                    this.isSurvey = true;
                    this.msg = this.lbl.confirm_redeem.default_survey;

                    if(this.campaign.interfaceDisplay == 'surveyapprove'){
                        this.msg2 = this.lbl.confirm_redeem.default_survey_approve_question;
                    }else{
                        this.msg2 = this.lbl.confirm_redeem.default_survey_question;
                    }
                    
                }
            } 
            console.log('cam', this.campaign)
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseImage.scss";
.wrapper-confirm-redeem{
    text-align: center;
    .confirm-redeem-headline{
        font-family: $medium;
        font-size: 1.25rem;
        color: $bright-gray;
        padding-top: 10px;
    }
    .campaign-img{
        @include baseRatioImg(66.66%);
        width: 60%;
        border: 1px solid $border-gray;
        border-radius: 15px;
        box-shadow: $box-shadow;
        margin: 20px auto;
    }
    .confirm-redeem-txt{
        font-size: 1.25rem;
        color: $bright-gray;

        span{
            font-family: $medium;
        }

        .text-pink{
            color: $pink;
        }

        img{
            border: 1px solid $border-gray;
            border-radius: 50%;
            box-shadow: $box-shadow;
            margin: {
                top: -3px;
                left: 10px;
            }
        }
    }
}


</style>
